import { Typography, notification } from 'antd'
import React, { FunctionComponent, useState } from 'react'
import { CreateTraderForm } from './createTrader'
import { TradersService } from '../api/services.gen'

export const TraderSimulatePage: FunctionComponent<{}> = (props) => {
  const [response, setResponse] = useState<any>(undefined)
  const [id, setId] = useState<string>('')

  const onFinish = async (values: any) => {
    values.meta = JSON.parse(values.meta)

    try {
      const res = await TradersService.simulateTrader({
        requestBody: {
          trader: {
            broker: values.broker,
            type: values.type,
            action: values.action,
            quantity: parseFloat(values.quantity),
            maxPositions: parseInt(values.maxPositions),
            minWin: parseFloat(values.minWin),
            currency: values.currency,
            offsetSeconds: parseInt(values.offsetSeconds),
            meta: values.meta
          }
        }
      })
      if (res.id) {
        notification.success({
          message: 'Trader simulation started',
          description: 'The response is displayed below'
        })
        setId(res.id)
        setResponse(res.simulation)

        const interval = setInterval(async () => {
          const sres = await TradersService.getSimulation({ simulationId: res.id })
          setResponse(sres.simulation)

          if (sres.simulation.status !== 'simulating') {
            clearInterval(interval)
          }
        }, 5 * 1000)
      }
    } catch (e: any) {
      console.error(e)
      notification.error({
        message: 'Error',
        description: e.toString()
      })
    }
  }

  return <>
    <Typography.Title level={3}>Simulate a trader</Typography.Title>

    <Typography.Title level={4}>Parameters</Typography.Title>
    <CreateTraderForm onFinish={onFinish} />

    <Typography.Title level={4}>Simulation result</Typography.Title>
    <Typography.Title level={5}>Status: {response?.status}</Typography.Title>
    <Typography.Text>{id}</Typography.Text>
    <pre>
      {response?.response ? JSON.stringify(response.response, null, 2) : 'No response yet'}
    </pre>
    <pre>
      {(response?.events ?? []).length > 0 ? response.events.join('\n') : 'No events yet'}
    </pre>
  </>
}